module.exports = __webpack_public_path__ + "img/采收管理图标.305fb235.svg";